export class UserForGridModel {
  public userId: number;
  public name: string;
  public email: string;
  public birthDate: string;
  public createdOn: string;
  public updatedOn: string;
  public lastLogged: string;
  public isDeleted: boolean;
  public isActive: boolean;
  public relationType: number;
  public medicineCount: number;
  public diseasesCount: number;
  public userTypeId: number;
  public requestStatusId: number;
  public notAllowedFoods: string;
  public allergies: string;
}